import { createQuery, type QueryClient } from '@tanstack/solid-query'
import { api } from '~/services/api'

type User = {
  id: number
  coin: number
  gem: number
  service_level: string
}

export const userQueryKey = ['user'] as const

export const useUser = () => {
  return createQuery(() => ({
    queryKey: userQueryKey,
    queryFn: async () => {
      return api.service.get('user/users/current').json<User>()
    },
  }))
}

// Optimistically mirror a coin/gem grant into the cached user so the top-nav
// pills reflect it immediately. Used by the Boosting Pack reward queue, which
// celebrates the (async, server-side) grant locally; the server value
// converges to the same total, so the cache never drifts.
export function adjustUserCurrency(
  queryClient: QueryClient,
  field: 'coin' | 'gem',
  delta: number,
) {
  queryClient.setQueryData<User>(userQueryKey, (old) =>
    old ? { ...old, [field]: Math.max(0, old[field] + delta) } : old,
  )
}
